interface CountCardProps {
  title: string;
  count: number;
  label: string;
  icon: string;
  colorClass: string;
  bgClass?: string;
  loading?: boolean;
  onClick?: () => void;
}

export default function CountCard({ title, count, label, icon, colorClass, bgClass, loading = false, onClick }: CountCardProps) {
  // Extract border color from colorClass
  const borderColor = colorClass.replace('text-', 'border-');

  return (
    <div 
      onClick={onClick}
      className={`${bgClass || 'bg-surface-container-lowest'} p-5 pr-10 rounded-2xl border border-outline-variant/10 shadow-sm flex items-center hover:translate-y-[-4px] hover:shadow-xl transition-all ${onClick ? 'cursor-pointer hover:border-primary/50' : 'cursor-default'} group shrink-0 border-l-4 ${borderColor} relative overflow-hidden w-full min-w-0`}
    >
      {/* Watermark Icon - Perfectly Aligned Background */}
      <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
        <div className={`${colorClass} opacity-[0.2] group-hover:opacity-[0.3] group-hover:scale-110 transition-all duration-700`}>
          <span className="material-symbols-outlined text-6xl leading-none select-none" style={{ fontVariationSettings: "'FILL' 1, 'wght' 700" }}>
            {icon}
          </span>
        </div>
      </div>

      <div className="space-y-0.5 relative z-10 w-full">
        <p className="text-[10px] font-black uppercase tracking-[0.15em] text-on-surface-variant/50 leading-none mb-1">{title}</p>
        <p className="text-3xl font-black text-on-surface tracking-tighter leading-none flex items-baseline gap-1.5">
          {loading ? (
            <span className="w-8 h-8 bg-on-surface/5 animate-pulse rounded-md inline-block" />
          ) : (
            <>
              {count} 
              <span className="text-[10px] font-extrabold text-on-surface-variant/30 tracking-normal uppercase">{label}</span>
            </>
          )}
        </p>
      </div>
    </div>
  );
}
